import React from "react";
import { queriesPayees } from "@query";
import { WSElement, WSText } from "@wingspanhq/fe-component-library";
import { selectorPayeeDisplayName } from "../../../../shared/selectors/selectorPayeeDisplayName";
import { useXWingspanPayerId } from "../../../Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

export const PayeeName: React.FC<{ payeeId: string }> = ({ payeeId }) => {
  const xWingspanAccount = useXWingspanPayerId();
  const queryPayee = queriesPayees.getPayee.useQuery({
    payeeId,
    xWingspanAccount
  });

  if (queryPayee.data) {
    return <>{selectorPayeeDisplayName(queryPayee.data)}</>;
  } else if (queryPayee.isError) {
    return <WSText.ParagraphXs color="red500">error</WSText.ParagraphXs>;
  } else {
    return <WSElement as="i" shimmer pb="L" style={{ display: "block" }} />;
  }
};
